export default __webpack_public_path__ + "static/media/color.7b796696.svg";